import React, { useState } from "react";
import styled from "styled-components";
import { Colors } from "../../config";
import Button from "../Button";
const PlaneRight = require("../../assets/images/airplane-right.png");
const PlaneLeft = require("../../assets/images/airplane-left.png");

const TutorialImg01 = require("../../assets/images/tut_01.png");
const TutorialImg02 = require("../../assets/images/tut_02.png");
const TutorialImg03 = require("../../assets/images/tut_03.png");
const TutorialImg04 = require("../../assets/images/tut_04.png");
const TutorialImg05 = require("../../assets/images/tut_05.png");
const TutorialImg06 = require("../../assets/images/tut_06.png");
const TutorialImg07 = require("../../assets/images/tut_07.png");
const TutorialImg08 = require("../../assets/images/tut_08.png");

const tutorial = [
  {
    heading: "Annual Ticket Balance",
    img: TutorialImg01,
    description: `The annual ticket balance feature enables employees to view their remaining ticket balance and plan their travel accordingly.
    However, if the employee has exhausted their ticket balance for the year, they can still book their travel tickets but at their own expense. Such bookings are considered self-paid.`,
  },
  {
    heading: "Travelling From",
    img: TutorialImg02,
    description: `Travelling From and Travelling To are two important details required when booking travel tickets. Travelling From refers to the location from which the journey will begin and is typically set as the employee's place of work. This detail is uneditable as it is a fixed location from where the employee will commence their journey.`,
  },
  {
    heading: "Destination",
    img: TutorialImg03,
    description: `The destination available to employees is determined by their ticket balance and nationality. Employees can choose an airport based on their nationality using the company-paid option. However, if they are willing to pay for their travel, they may have the freedom to choose any destination without any restrictions.`,
  },
  {
    heading: "Travel details",
    img: TutorialImg04,
    description: `.Employees are required to choose their preferred travel and return dates and times when booking their travel tickets. 
    Additionally, they have the option to select their preferred airline for the journey.`,
  },
  {
    heading: "Payment Type",
    img: TutorialImg05,
    description: `The company-paid and self-paid options for booking travel tickets offer employees the flexibility to choose between traveling to their nationality destinations or any other destination based on their ticket balance. If an employee has an available ticket balance, they can opt for company-paid or select self-paid travel to any destination of their choice. However, if the employee does not have an annual ticket balance, they must choose self-paid travel`,
  },
  {
    heading: "Special Requests",
    img: TutorialImg06,
    description: `When booking flight tickets for yourself and your dependents, you can include special requests such as dietary requirements, wheelchair assistance, or other needs. This ensures a comfortable and hassle-free travel experience for everyone involved.`,
  },
  {
    heading: "Add Guest",
    img: TutorialImg07,
    description: `Adding guests on the travel booking platform enables employees to bring companions on their trip at their own expense. This feature provides flexibility for employees to book travel tickets for themselves and their guests in a single transaction.`,
  },
  {
    heading: "Want to know more about the PowerFLY",
    img: TutorialImg08,
    description: `The FAQ section on Travel App offers detailed information about booking travel tickets using an employee's annual balance. You can access the FAQs by clicking on your profile picture, which will direct you to the section. The FAQs provide answers to common queries and clarifies how the app works for employees.`,
  },
];

const Tutorials = ({ onDone }) => {
  const [activeTutorial, setTutorial] = useState(0);
  return (
    <TutorialsContainer>
      <TutorialPanel>
        <PanelTop>
          <PanelHeading>{tutorial[activeTutorial].heading}</PanelHeading>
          <img src={tutorial[activeTutorial].img} />
        </PanelTop>
        <PanelBottom>
          <span>{tutorial[activeTutorial].description}</span>
        </PanelBottom>
        <PanelActions>
          {activeTutorial === 0 ? (
            <div style={{ width: "10rem" }}></div>
          ) : (
            <Button
              topBottomPadding="0.75rem"
              width="10rem"
              label={"Back"}
              leftImgSrc={PlaneLeft}
              bgColor={Colors.brandOne}
              onClick={() => setTutorial(Number(activeTutorial) - 1)}
            />
          )}
          {activeTutorial === tutorial.length - 1 ? (
            <Button
              topBottomPadding="0.75rem"
              width="10rem"
              label={"Done"}
              rightImgSrc={PlaneRight}
              bgColor={Colors.brandOne}
              onClick={onDone}
            />
          ) : (
            <Button
              topBottomPadding="0.75rem"
              width="10rem"
              label={"Next"}
              rightImgSrc={PlaneRight}
              bgColor={Colors.brandOne}
              onClick={() => setTutorial(Number(activeTutorial) + 1)}
            />
          )}
        </PanelActions>
      </TutorialPanel>
    </TutorialsContainer>
  );
};

const PanelHeading = styled.div`
  text-align: center;
  font-size: 1.5rem;
  color: ${Colors.brandOne};
  font-weight: 600;
  padding: 1rem 0;
  @media only screen and (max-width: 768px) {
    font-size: 1.15rem;
  }
`;
const PanelActions = styled.div`
  width: 100%;
  justify-content: center;
  display: flex;
  gap: 1rem;
  position: absolute;
  bottom: -1.5rem;
  @media only screen and (max-width: 768px) {
    gap: 0.25rem;
  }
`;
const PanelTop = styled.div`
  background: ${Colors.brandFive};
  padding: 1.5rem;
  border-top-left-radius: 1rem;
  border-top-right-radius: 1rem;
  text-align: center;

  > img {
    width: 80%;
  }
  @media only screen and (max-width: 768px) {
    padding: 1rem;
    > img {
      width: 100%;
    }
  }
`;
const PanelBottom = styled.div`
  padding: 1.5rem;
  padding-bottom: 2.5rem;
  background: white;
  border-bottom-left-radius: 1rem;
  border-bottom-right-radius: 1rem;
  text-align: center;
  > span {
    font-size: 1rem;
    color: ${Colors.brandOne};
    font-weight: 600;
    line-height: 2rem;
  }
  @media only screen and (max-width: 768px) {
    padding: 1rem;
    padding-bottom: 2rem;
    > span {
      font-size: 0.9rem;
      color: ${Colors.brandOne};
      font-weight: 600;
      line-height: 1rem;
    }
  }
`;
const TutorialsContainer = styled.div`
  position: absolute;
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.2);
  -webkit-backdrop-filter: blur(10px);
  backdrop-filter: blur(10px);
  z-index: 99999;
  justify-content: center;
  align-items: center;
  display: flex;
`;

const TutorialPanel = styled.div`
  width: 40%;
  position: relative;
  @media only screen and (max-width: 768px) {
    width: 75%;
  }
`;

export default Tutorials;
